import useMediaQuery from 'beautiful-react-hooks/useMediaQuery';

// hook function to get window innerWidth and not break Swiper carousels.
function useIsDesktop(): boolean {
  const isDesktop = useMediaQuery(`print, (min-width: 960px)`);
  return isDesktop;
}

export default useIsDesktop;
